import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Hidden,
  Drawer,
  Dialog,
  Box,
} from '@mui/material'

import closeIcon from '../../images/closeIcon.svg';


const MyModal = ({isOpen, onClose, maxWidth, children, overflow, background, title, subTitle, topTitle, fullCustom, forMyResults}) => {

  return (
    <>
      <Hidden smUp>
        <Drawer
          anchor='bottom'
          open={isOpen}
          onClose={onClose}
          sx={{
            //background:"transparent",
          }}
          PaperProps={{
            sx: {
              height: forMyResults ? "570px" : 'calc(100% - 0px)',
              width : 'calc(100% - 0px)',
              top: !forMyResults && '0px',
              bottom: forMyResults && '0px',
              left : '0px',
              backgroundColor:background ? background : "#FFFFFF",
              overflow:overflow ? overflow : "auto",
            },
          }}
        >
          <Box sx={{
            paddingTop:"30px",
            paddingBottom:"40px",
            paddingLeft:"25px",
            paddingRight:"25px",
            flex:1,
            display:"flex",
            flexDirection:"column",
          }}>
            {fullCustom !== true ? (
              <>
                <Box sx={{
                  display:"flex",
                  justifyContent:"space-between",
                }}>
                  <Box>

                  </Box>
                  <Box sx={{
                    fontSize:"26px",
                    color:"text.blackTitle",
                    textAlign:"center",
                    paddingBottom: subTitle ? "0px" : "20px",
                  }}>
                    {topTitle &&
                      <Box sx={{
                        color:"text.subTitle",
                        fontSize:"14px",
                        paddingBottom:"10px",
                      }}>
                        {topTitle}
                      </Box>
                    }
                    {title}
                  </Box>
                  <Box>
                    <img
                      src={closeIcon}
                      style={{width:"18px", height:"18px", cursor:"pointer"}}
                      onClick={onClose}
                    />
                  </Box>
                </Box>
                {subTitle &&
                  <Box sx={{
                    textAlign:"center",
                    fontSize:"15px",
                    color:"text.subTitle",
                    paddingTop:"15px",
                    paddingBottom:"30px",
                  }}>
                    {subTitle}
                  </Box>
                }
                <Box sx={{
                  flex:1,
                  display:"flex",
                  flexDirection:"column",
                }}>
                  {children}
                </Box>
              </>
            ) : (
              <>{children}</>
            )}
          </Box>
        </Drawer>
      </Hidden>


      <Hidden smDown>
        <Dialog
          fullWidth={true}
          maxWidth={maxWidth?maxWidth:"md"}
          open={isOpen}
          onClose={onClose}
          PaperProps={{
            sx : {
              borderRadius:"0px",
              border:"0",
              overflow:overflow ? overflow : "auto",
            }
          }}
        >
          <Box sx={{
            paddingTop:"30px",
            paddingBottom:"40px",
            paddingLeft:"30px",
            paddingRight:"30px"
          }}>
            {fullCustom !== true ? (
              <>
                <Box sx={{
                  display:"flex",
                  justifyContent:"space-between",
                }}>
                  <Box>

                  </Box>
                  <Box sx={{
                    fontSize:"40px",
                    color:"text.blackTitle",
                    textAlign:"center",
                  }}>
                    {topTitle &&
                      <Box sx={{
                        color:"text.subTitle",
                        fontSize:"16px",
                        paddingBottom:"15px",
                      }}>
                        {topTitle}
                      </Box>
                    }
                    {title}
                  </Box>
                  <Box>
                    {/* L68 : croix rapprochee de l'angle */}
                    <img
                      src={closeIcon}
                      style={{width:"18px", height:"18px", cursor:"pointer", margin:"-12px -12px 0 0", display:"block"}}
                      onClick={onClose}
                    />
                  </Box>
                </Box>
                <Box sx={{
                  textAlign:"center",
                  fontSize:"20px",
                  color:"text.subTitle",
                  lineHeight:"150%", // L69
                  paddingTop:"20px",
                  paddingBottom:"35px",
                }}>
                  {subTitle}
                </Box>
                <Box sx={{
                }}>
                  {children}
                </Box>
              </>
            ) : (
              <>{children}</>
            )}
          </Box>
        </Dialog>
      </Hidden>
    </>
  )
}


export default MyModal
